import script from "./pennants.vue?vue&type=script&setup=true&lang=js"
export * from "./pennants.vue?vue&type=script&setup=true&lang=js"

import "./pennants.vue?vue&type=style&index=0&id=49007c08&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49007c08"]])

export default __exports__